/* ============================================================
   PERF: Instagram Feed — disable auto-preloading of videos
   
   The GSC Instagram Feed widget renders <video> elements with
   preload="auto". This tells the browser to immediately start
   downloading every Instagram video on the page, even if the
   user never scrolls to or plays them.
   
   This fix intercepts those video elements and sets
   preload="none" so videos only load when actually played.
   Uses MutationObserver to catch elements injected after the
   initial page load (the feed renders asynchronously).
   ============================================================ */

(function () {
  'use strict';

  function fixInstagramVideos(root) {
    var videos = root.querySelectorAll('video.gfa-media__source');
    videos.forEach(function (video) {
      if (video.getAttribute('preload') === 'auto') {
        video.setAttribute('preload', 'none');

        // Pause any loading already in progress
        video.pause();
        video.load();
      }
    });
  }

  // Handle videos already in the DOM at script execution time
  document.addEventListener('DOMContentLoaded', function () {
    fixInstagramVideos(document);
  });

  // Handle videos injected dynamically after page load (feed renders async)
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Check if the added node itself is the target video
          if (node.matches && node.matches('video.gfa-media__source')) {
            if (node.getAttribute('preload') === 'auto') {
              node.setAttribute('preload', 'none');
              node.pause();
              node.load();
            }
          }
          // Check children of added node
          fixInstagramVideos(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
